export default __webpack_public_path__ + "static/media/card_5.8d430f2d.svg";